// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__2HXRB","subSection":"About_subSection__tAmvE","images":"About_images__RXd4M","subWrap":"About_subWrap__LB+VJ","img":"About_img__Z35Xj"};